import type { FC } from "react";
import { memo } from "react";

import { swSettings } from "app/common/services/swSettings";
import { shouldSeeReactivationBanner } from "app/common/utils";
// todo: SI-7503
import { AfterTrialBannerB } from "app/components/React/AfterTrialBanner/AfterTrialBannerB";
import type { StaticListType } from "app/pages/sales-intelligence/domain/lists/types/static-list-model";
import { QuickActionsContainer } from "app/pages/sales-intelligence/modules/suggestions/containers/QuickActionsContainer/QuickActionsContainer";
import useSuggestedActionQuery from "app/pages/sales-intelligence/modules/suggestions/query/queries/useSuggestedActionQuery";
import { DownloadExtensionBanner } from "app/pages/sales-intelligence/pages/home/components/DownloadExtensionBanner/DownloadExtensionBanner";
import { IndustryTaxonomyHomeBanner } from "app/pages/sales-intelligence/pages/home/components/industry-taxonomy-banner/IndustryTaxonomyHomeBanner";
import { useShowsIndustryTaxonomyHomeBanner } from "app/pages/sales-intelligence/modules/industry/hooks/useShowsIndustryTaxonomyHomeBanner";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isSalesExtensionPresent } from "app/pages/sales-intelligence/utils/extension";
import { isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import CSVEnrichmentContainer from "../../containers/CSVEnrichmentContainer/CSVEnrichmentContainer";
import ListsCardWithErrorBoundary from "../../containers/ListsCardContainer/ListsCardWithErrorBoundary";
import SavedSearchesCardWithErrorBoundary from "../../containers/SavedSearchesCardContainer/SavedSearchesCardWithErrorBoundary";
import TopCompaniesContainer from "../TopCompaniesContainer/TopCompaniesContainer";

import { StyledCardsContainer, StyledCardWrapper } from "./styles";

type HomePageContentProps = {
    opportunityLists: readonly StaticListType[];
};

const HomePageContent: FC<HomePageContentProps> = (props) => {
    const { opportunityLists } = props;
    const { data, isFetching } = useSuggestedActionQuery();

    const isShowReactivationBanner = shouldSeeReactivationBanner();
    const showsIndustryTaxonomyHomeBanner = useShowsIndustryTaxonomyHomeBanner();

    const showsDownloadExtensionBanner =
        !showsIndustryTaxonomyHomeBanner &&
        (isTrial(swSettings) || isNoTouch(swSettings) || !salesSettingsHelper.isHighLevelAccount()) &&
        !isSalesExtensionPresent();

    return (
        <StyledCardsContainer>
            <IndustryTaxonomyHomeBanner />
            {showsDownloadExtensionBanner ? <DownloadExtensionBanner /> : null}
            {!showsIndustryTaxonomyHomeBanner && isShowReactivationBanner ? (
                <StyledCardWrapper>
                    <AfterTrialBannerB isSI />
                </StyledCardWrapper>
            ) : null}
            <StyledCardWrapper data-automation="quick-actions-wrapper">
                <QuickActionsContainer
                    suggestedActions={data?.suggestedActions || []}
                    isLoading={isFetching}
                />
            </StyledCardWrapper>
            <StyledCardWrapper data-automation="top-companies-wrapper">
                <TopCompaniesContainer />
            </StyledCardWrapper>
            <StyledCardWrapper data-automation="my-lists-wrapper">
                <ListsCardWithErrorBoundary />
            </StyledCardWrapper>
            <StyledCardWrapper data-automation="saved-searches-wrapper">
                <SavedSearchesCardWithErrorBoundary />
            </StyledCardWrapper>
            <StyledCardWrapper data-automation="csv-enrichment-wrapper">
                <CSVEnrichmentContainer lists={opportunityLists} />
            </StyledCardWrapper>
        </StyledCardsContainer>
    );
};

export default memo(HomePageContent);
